import SimpleBar from "simplebar";
import spinner from "./spinner";

jQuery = $;

// Function to load a single JavaScript file
function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve(src);
        script.onerror = () => reject(new Error(`Failed to load script ${src}`));
        document.head.appendChild(script);
    });
}

// Function to load multiple JavaScript files
function loadScripts(scripts, callback) {
    Promise.all(scripts.map(loadScript))
        .then(callback)
        .catch(error => console.error(error));
}

export default function mapEnogea() {
    var debug = true;

    var options = {
        animInterval: null,
        enableAnimationPointer: typeof cdbMapParams !== "undefined" && cdbMapParams.enableAnimationPointer ? cdbMapParams.enableAnimationPointer : 0
    }
    var currentPanoID = typeof cdbMapParams !== "undefined" && cdbMapParams.currentPanoID ? cdbMapParams.currentPanoID : -1;
    var userLevel = typeof cdbMapParams !== "undefined" && cdbMapParams.userLevel ? cdbMapParams.userLevel : 1;
    var always_show = typeof cdbMapParams !== "undefined" && typeof cdbMapParams.hideMapOnMobile !== "undefined" ? !cdbMapParams.hideMapOnMobile : 0;
    var autorotate = false;
    var isAutologin = typeof cdbMapParams !== "undefined" && cdbMapParams.isAutologin ? cdbMapParams.isAutologin : false;

    var pano_0_500 = null, skin_0_500 = null, nodesList, maxPanoNodes, maxLevels;

    var pano_current_nodeId,
        interfaceLevel = typeof cdbMapParams !== "undefined" && cdbMapParams.interfaceLevel ? cdbMapParams.interfaceLevel : -1,
        pano_current_ggpkg_name = undefined;

    /**
     * Retrieve and init vineyard parcel info into modal
     * @param parcelId
     * @returns {number}
     */
    function initInfoLevel3(parcelId) {
        let description = '', vineyardNode = null, parcel = null;
        if (pano_current_nodeId) {
            if (debug) {
                console.log('*** initInfoLevel3 parcelId=' + parcelId + ' pano_current_nodeId=' + pano_current_nodeId);
            }
            // search is simple
            vineyardNode = pano_data.vineyards_repeater.filter(x => x.node_id == pano_current_nodeId);
            if (vineyardNode) {
                for (let i = 0; i < vineyardNode.length && !parcel; i++) {
                    if (vineyardNode[i] && vineyardNode[i].parcels_repeater) {
                        parcel = vineyardNode[i].parcels_repeater.find(x => x.polygon_hotspot_id == parcelId);
                    }
                }
            }
        } else {
            // search is complex
            let parcel = false, i = 0;
            while (!parcel && i < pano_data.vineyards_repeater.length) {
                vineyardNode = pano_data.vineyards_repeater[i];
                parcel = vineyardNode.parcels_repeater.find(x => x.polygon_hotspot_id == parcelId);
                i++;
            }
        }
        if (parcel) {
            description = "<p>" + parcel.parcel_long_description + "</p>";
            let $parcelInfo = $('#parcelInfo');
            $parcelInfo.find('h3').html(parcel.parcel_name);
            if (parcel.parcel_subtitle) {
                $parcelInfo.find('.subtitle').html(parcel.parcel_subtitle);
                $parcelInfo.find('.subtitle').show();
            } else {
                $('#parcelInfo').find('.subtitle').hide();
            }
        }
        $('[data-parcel-content]').empty().html(description);
        return description.length;
    }

    /**
     * Open vineyard parcel
     * (used by pano2vr object)
     * @param id
     * @returns {boolean}
     */
    window.openParticella = function (id) {
        if (debug) {
            console.log('** openParticella ' + id);
        }

        if (typeof event !== 'undefined') {
            event.stopImmediatePropagation();
        }

        // Close opened toggled panel
        $('[data-panel-toggled].show').removeClass('show');
        $('[data-panel-to-toggle].active').removeClass('active');

        let panelToToggle = $('#parcelInfo');
        if (panelToToggle) {
            panelToToggle.removeClass('show');
            if (interfaceLevel === 3) {
                setTimeout(function () {
                    if (initInfoLevel3(id)) {
                        console.log(SimpleBar.instances)
                        var scroller = panelToToggle.find('div.scroller');
                        var appo = SimpleBar.instances.get(scroller[0]);
                        if (appo) {
                            appo.recalculate();
                            if (appo.getScrollElement()) {
                                appo.getScrollElement().scrollTop = 0;
                            }
                        }

                        // Open info side panel with info automatically
                        panelToToggle.addClass('show');
                    }
                }, 250); // small delay to show the lightbox opening if one is already open
            }
        }
        return true;
    }

    /**
     * Rotation Command
     * @param start
     */
    window.rotateMap = function (start) {
        if (start) {
            pano_0_500.startAutorotate(0.05, 60, 60);
        } else {
            pano_0_500.stopAutorotate();
        }
    }

    /**
     *  Manage changing Pano2VR panoramas
     */
    function updatePano2VRContent(panoID) {
        if (debug) {
            console.log('-- updatePano2VRContent panoID: ' + panoID + ' --');
        }

        if ((!always_show) && window.matchMedia('(max-width: 450px)').matches) {
            // Mobile and small screens
            $('.pano-alert-msg').show(); // shows failure to support message for screens < 450px
        } else {
            // Desktop and big screens
            $('.pano-alert-msg').hide(); // hide failure to support message for screens >= 450px
        }

        // Update map
        currentPanoID = panoID;
        // Show loading
        showLoader();

        var viewerMap = document.querySelector('.pano-viewer--map');
        var vineyardsList = document.querySelectorAll('.infopointlist,.infopoint');
        var btnBack = document.querySelector('.command-interface .btn-back');
        var vineyardSelector = document.querySelector('.command-interface .vineyard-selector');
        var levelSelector = document.querySelector('.command-interface .level-selector');

        // Reset previously instantiated properties
        _resetWindowInstantiatedProperties();

        if (currentPanoID <= 0) {
            //  Step 0 Mappa con viste 360
            initStepInitial();
            hideLoader();
        } else {
            //  Step 1 è stata selezionata una vista/vigneto
            $('.pano-section').css('opacity', 1);
            var basePanoFolder = $('#a_u').val().split('.ggpkg')[0] + '/';
            var urlPlayer = basePanoFolder + 'pano2vr_player.js';
            urlPlayer = '/wp-content/themes/cadelbosco/js/pano2vr/7.1.1a/pano2vr_player.js';
            var urlSkin = basePanoFolder + 'skin.js';
            pano_current_ggpkg_name = /[^/]*$/.exec($('#a_u').val().split('.ggpkg')[0])[0];

            const scriptUrls = [];

            // Load pano2vr scripts if undefined
            if (typeof pano2vrPlayer == 'undefined') {
                scriptUrls.push(urlPlayer);
            }
            if (typeof pano2vrSkin == 'undefined') {
                scriptUrls.push(urlSkin);
            }

            if (scriptUrls.length > 0) {
                loadScripts(scriptUrls, () => {
                    if (debug)
                        console.log('All pano2vr scripts loaded successfully');
                    updatePano2VRContentPlayer(basePanoFolder);
                });
            } else {
                updatePano2VRContentPlayer(basePanoFolder);
            }

            // Instructions button
            if ($('#helpInfo').length) {
                $('[data-role="help-info"]').removeClass('hide');
            }

            goToStepOneNew();

            // Hide loading
            hideLoader();

        }

        function updatePano2VRContentPlayer(basePanoFolder) {
            var cnt = $('#pano-viewer-ajax .pano-viewer-ajax > .content');
            var obj = $(cnt).children()[0];
            var theId = $(obj).attr('id');
            pano_0_500 = skin_0_500 = null;

            if (pano_current_ggpkg_name && window.hasOwnProperty(pano_current_ggpkg_name + '_pano2vrPlayer')) {
                pano_0_500 = new window[pano_current_ggpkg_name + '_pano2vrPlayer'](theId);
                if (debug) {
                    console.log('--- retrieve already instantiated ' + pano_current_ggpkg_name + '_pano2vrPlayer');
                }
            } else {
                pano_0_500 = new pano2vrPlayer(theId);
            }
            if (pano_current_ggpkg_name && window.hasOwnProperty(pano_current_ggpkg_name + '_pano2vrSkin')) {
                skin_0_500 = new window[pano_current_ggpkg_name + '_pano2vrSkin'](
                    pano_0_500,
                    basePanoFolder
                );
                if (debug) {
                    console.log('--- retrieve already instantiated ' + pano_current_ggpkg_name + '_pano2vrSkin');
                }
            } else {
                skin_0_500 = new pano2vrSkin(
                    pano_0_500,
                    basePanoFolder
                );
            }


            // trigger PANO changenode
            pano_0_500.readConfigUrlAsync(
                basePanoFolder + "pano.xml"
            );

            // change projection (note: setProject(9) not work)
            //pano_0_500.changeProjection(9, .1); //4 – Rectilinear, 9 – Stereographic, 12 – Fisheye.

            var contentOverflow = document.getElementById("content")
                ? document.getElementById("content").style.overflow
                : "";
            pano_0_500.off("fullscreenenter");
            pano_0_500.on("fullscreenenter", function () {
                if (document.getElementById("content")) {
                    document.getElementById("content").style.overflow = "visible";
                }
            });
            pano_0_500.off("fullscreenexit");
            pano_0_500.on("fullscreenexit", function () {
                if (document.getElementById("content")) {
                    document.getElementById("content").style.overflow = contentOverflow;
                }
            });
            pano_0_500.off("changenode");
            pano_0_500.on("changenode", function (event) {
                if (debug) {
                    console.log(' --- PANO changenode ---');
                }
                if (options.animInterval) window.clearInterval(options.animInterval);

                nodesList = pano_0_500.getNodeIds();
                maxPanoNodes = nodesList.length;
                maxLevels = maxPanoNodes;
                pano_current_nodeId = pano_0_500.getCurrentNode();

                if (maxPanoNodes > 3) maxLevels = 3;

                // Update interface
                setInterfaceLevel(pano_current_nodeId);

            });

            // Init click events
            initEventHandle();
        }

        /**
         * Show loader on pano-container
         */
        function showLoader() {
            if (debug) {
                console.log(' -- show loader --');
            }
            spinner().create('pano-loader', document.querySelector('.pano-container'));
        }

        /**
         * Hide and remove loader on pano-container
         */
        function hideLoader() {
            if (debug) {
                console.log(' -- call hide loader --');
            }

            setTimeout(function () {
                if (debug) {
                    console.log(' -- removed loader --');
                }
                spinner().hide('pano-loader'); // remove 'show' class
                $('.pano-container').find('#pano-loader').remove()
            }, 250);
        }

        /**
         * Init initial step with zoomMap and enogeaMap with numbered points
         * Execute on "discover the vineyards" button click
         */
        function initStepInitial() {
            if (debug) {
                console.log('--- initStepInitial ---');
            }

            // Init custom scroll bar for small and medium screens (< 1024px)
            if (window.matchMedia('(max-width: 1023px)').matches) {
                $('[data-simplebar-mobile]').each((index, el) => new SimpleBar(el));
            }

            goToStepInitial();
            initEventHandle(); // necessary for autologin map page

        }

        /**
         * Set initial step elements visibility
         */
        function goToStepInitial() {
            // Reset current panoID
            currentPanoID = -1;
            // Show map
            viewerMap.classList.remove('hide');
            // Hide back btn on command-toolbar
            btnBack.classList.add('hide');
            // Hide step 1 buttons
            vineyardSelector.classList.add('hide');
            levelSelector.classList.add('hide');
            $('.level23').hide();
            $('.btn-menu-mobile').addClass('hide');
            $('.map-title').removeClass('hide');
            // hide pano toolbar visibility btn
            $('#btnToolbarVisibility').addClass('hide').removeClass('show-map-toolbar');
            // Close opened menu
            closeMenu();
            // Enable map points animation
            if (options.enableAnimationPointer) {
                initPointsAnimation();
            }
            // Reset interface level
            interfaceLevel = 0;

            // Reset pano2vr
            pano_0_500 = skin_0_500 = null;
            _resetWindowInstantiatedProperties();
        }

        /**
         * Set step one elements visibility
         * @param id
         * @param posx
         * @param posy
         */
        function goToStepOneNew() {
            // hide map title
            $('.map-title').addClass('hide');
            // show pano toolbar visibility btn
            $('#btnToolbarVisibility').removeClass('hide');
            // terminate points animation
            if (options.animInterval) window.clearInterval(options.animInterval);
            // Hide initial map
            //viewerMap.classList.add('hide');
            // Show back btn on command-toolbar
            btnBack.classList.remove('hide');
            // Show step 1 buttons
            vineyardSelector.classList.remove('hide');
            if (userLevel > 1) {
                levelSelector.classList.remove('hide');
            }
            $('.btn-menu-mobile').removeClass('hide');

        }

        /**
         * Retrieve and init vineyard title and long description into [data-vineyard-content] panel
         * @returns {number} content length
         */
        function initInfoLevel1() {
            let longDescription = '';
            if (pano_data.title) longDescription = "<h3>" + pano_data.title + "</h3><div>";
            longDescription += pano_data.long_description;
            if (pano_data.title) longDescription += "</div>";
            $('[data-vineyard-content]').empty().html(longDescription);
            return (longDescription && longDescription.length);
        }

        /**
         * Retrieve and init vineyard node title and description into [data-vineyard-content] panel
         * @returns {number} content length
         * @param nodeId vineyard node ID
         */
        function initInfoLevel2(nodeId) {
            let nodeDescription = '';
            let vineyardNode = pano_data.vineyards_repeater.find(x => x.node_id == nodeId);
            if (vineyardNode) {
                nodeDescription = "<h3>" + vineyardNode.vineyard_name + "</h3><div>" + vineyardNode.vineyard_description + "</div>"
            }
            $('[data-vineyard-content]').empty().html(nodeDescription);
            return nodeDescription.length;
        }

        /**
         * Init numbered points animation
         */
        function initPointsAnimation() {
            var originalBorder = 0;

            function bounce_z(oggetto) {
                $(oggetto).css('border-width', originalBorder);
            }

            function bounce_a(oggetto) {
                originalBorder = $(oggetto).css('border-width');
                $(oggetto).css('border-width', '5px');
                setTimeout(bounce_z, 250, oggetto);
            }

            function draw() {
                $('.map-point').each(function (index) {
                    setTimeout(bounce_a, index * 200, $(this));
                });
            }

            clearInterval(options.animInterval);
            options.animInterval = window.setInterval(draw, 2500);
        }

        /**
         * Init events
         */
        function initEventHandle() {
            initEventClickHandle();
            initEventResizeHandle();
        }

        /**
         * Add events to buttons, map points, menu, panel resize, etc
         */
        function initEventClickHandle() {

            // Add click event on 360 views list and on points map
            let currentUrl = window.location.href.split('?')[0];
            [].forEach.call(vineyardsList, function (vineyard) {
                $(vineyard).off('click').on('click', (e) => {
                    if (debug) {
                        console.log('- CLICK vineyard list item -');
                    }

                    let id = e.currentTarget.attributes['data-id'].nodeValue;
                    window.location.href = currentUrl + '?vId=' + id;
                    closeMenu();
                });
            });

            // Level change script
            $('.command-interface .changer').each(function (index) {
                $(this).off("click").on("click", function (event) {
                    if (debug) {
                        console.log('- CLICK level changer -');
                    }
                    if (typeof event !== 'undefined') {
                        event.stopPropagation();
                    }
                    let level = $(this).attr('data-level');
                    if (parseInt(level) !== parseInt(interfaceLevel)) changeLevel(level);
                });
            });

            //  btn-back click event management
            $('.command-interface .btn-back').off("click").on('click', (event) => {
                if (debug) {
                    console.log('- CLICK back btn -');
                }
                if (typeof event !== 'undefined') {
                    event.stopPropagation();
                }
                window.location.href = currentUrl;
                //goToStepInitial();
            })

            //  data-panel-to-open and data-panel-to-close click event management, used to open and close Zoom Map
            $('[data-panel-to-open]').off('click').on('click', function (event) {
                if (debug) {
                    console.log('- CLICK open panel: ' + $(this).data('panel-to-open') + '-');
                }
                if (typeof event !== 'undefined') {
                    event.stopPropagation();
                }
                $(document).trigger('resizeSidePanels');

                let panelToOpenId = $(this).data('panel-to-open');
                let panelToOpen = $('#' + panelToOpenId);
                if (panelToOpen) {
                    panelToOpen.removeClass('hide');
                    $(this).addClass('active');
                }
            });
            $('[data-panel-to-close]').off('click').on('click', function (event) {
                if (debug) {
                    console.log('- CLICK close panel: ' + $(this).data('panel-to-close') + '-');
                }
                if (typeof event !== 'undefined') {
                    event.stopPropagation();
                }
                let panelToCloseId = $(this).data('panel-to-close');
                let panelToClose = $('#' + panelToCloseId);
                if (panelToClose) {
                    panelToClose.addClass('hide');
                    $('.active[data-panel-to-open="' + panelToCloseId + '"]').removeClass('active');
                }
            })

            //  data-panel-to-toggle click event management, used to open and close vineyards list and vineyard info
            $('[data-panel-to-toggle]').off("click").on("click", function (event) {
                if (debug) {
                    console.log('- CLICK [data-panel-to-toggle] -');
                }

                if (typeof event !== 'undefined') {
                    event.stopImmediatePropagation();
                }

                $(document).trigger('resizeSidePanels');

                if (event.target !== $('[data-panel-to-toggle].active')[0]
                    && $(event.target).parents('[data-panel-to-toggle].active').length <= 0) {
                    // hide panel and deactivate other active buttons
                    $('[data-panel-toggled].show').removeClass('show');
                    $('[data-panel-to-toggle].active').removeClass('active');
                    $('[data-panel-to-toggle].active-info').removeClass('active-info');
                }

                let panelToToggleId = $(this).data('panel-to-toggle');
                let panelToToggle = $('#' + panelToToggleId);
                if (panelToToggle) {
                    panelToToggle.toggleClass('show');
                    $(this).toggleClass('active');
                }
            });

            // Add a click event listener to the close button or anywhere outside the panel to close vineyards list and vineyard info
            $('[data-panel-toggled] .close').off("click").on("click", function (event) {
                if (debug) {
                    console.log('- CLICK [data-panel-toggled] close -');
                }
                // hide vineyards list
                if (typeof event !== 'undefined') {
                    event.stopPropagation();
                }
                $(this).parents('[data-panel-toggled]').removeClass('show');
                $('[data-panel-to-toggle].active').removeClass('active');
            });

            $(window).off('click').on("click", function (event) {
                if (event.target !== $('[data-panel-toggled].show')[0]
                    && ($(event.target).parents('[data-panel-toggled].show').length <= 0
                        || $(event.target).attr('data-close-panel-on-click')
                    )
                    && event.target !== $('[data-panel-to-toggle].active')[0]
                    && $(event.target).parents('[data-panel-to-toggle].active').length <= 0
                    && ($(event.target).data('role') !== "panovr-menu-trigger" && $(event.target).parents('[data-role="panovr-menu-trigger"]').length <= 0)
                ) {
                    if (debug) {
                        console.log('- CLICK window HIDE active panels -');
                    }
                    // hide panel and deactivate other active buttons
                    $('[data-panel-toggled].show').removeClass('show');
                    $('[data-panel-to-toggle].active').removeClass('active');
                    $('[data-panel-to-toggle].active-info').removeClass('active-info');
                }
            });

            // Add click event to menu that toggle the bottom bar (used on mobile dev)
            $('[data-role="panovr-menu-trigger"]').off('click').on('click', function (event) {
                if (debug) {
                    console.log('- CLICK bar menu -');
                }
                if (typeof event !== 'undefined') {
                    event.stopPropagation();
                }

                var menuContainer = $('[data-role="panovr-menu-content"]');
                if (menuContainer.length) {
                    menuContainer.toggleClass('show');
                }
                $(this).parents('.command-interface').toggleClass('open');
                $(document).trigger('resizeSidePanels');
            });


            // Add click evento to show/hide Pano toolbar
            $('#btnToolbarVisibility').off('click').on('click', function () {
                $('.ggskin.ggskin_container').toggleClass('hide');
                $('.ggskin.ggskin_scrollarea').each(function () {
                    if ($(this).prop('ggId') === "thumbnail_menu")
                        $(this).toggleClass('hide');
                });


                $(this).toggleClass('show-map-toolbar');
            });

            // Add events click to close infoWindow
            let panoViewer = $('.pano-viewer');
            if (panoViewer) {
                let infoWindow = panoViewer.find('.infowindow');
                let infoWindowCloseBtn = infoWindow.find('.close');

                //  Init close infowindow
                $(infoWindowCloseBtn).off("click").on('click', (event) => {
                    if (debug) {
                        console.log('** CLOSE particella');
                    }
                    if (typeof event !== 'undefined') {
                        event.stopPropagation();
                    }
                    infoWindow.removeClass('show');
                });

                $(document).mouseup(function (e) {
                    // If the target of the click isn't the container
                    if (!infoWindow.is(e.target) && infoWindow.has(e.target).length === 0) {
                        infoWindow.removeClass('show');
                    }
                });
            }

        }

        /**
         * 'resizeSidePanels' event management
         */
        function initEventResizeHandle() {
            // Trigger 'resizeSidePanels' event on window.resize
            $(window).resize(function () {
                $(document).trigger('resizeSidePanels');

                if ((!always_show) && window.matchMedia('(max-width: 450px)').matches) {
                    // Mobile and small screens
                    $('.pano-alert-msg').show(); // shows failure to support message for screens < 768px
                } else {
                    // Desktop and big screens
                    $('.pano-alert-msg').hide(); // hide failure to support message for screens >= 768px
                }
            });

            // Resize left info panel
            $(document).off('resizeSidePanels').on('resizeSidePanels', function () {
                if (debug) {
                    console.log(' --- resizeSidePanels ---');
                }
                var calcHeight = $('.pano-section').height() - $('.command-interface').height();
                $('.side-panel').outerHeight(calcHeight);
            });
        }

        /**
         * Close bottom bar on mobile visualization
         */
        function closeMenu() {
            if (debug) {
                console.log(' --- closeMenu ---');
            }
            $('[data-role="panovr-menu-content"]').removeClass('show');
            $('.command-interface').removeClass('open');
            $(document).trigger('resizeSidePanels');
        }

        // *******************************************************************
        // *** LEVEL MANAGEMENT FUNCTIONS PANORAMA PARTICLE INTERFACE      ***
        // *******************************************************************

        /**
         * Opens the vineyard information panel (level 2 and 3)
         * @param nodeId
         */
        function openVineyardInfo(nodeId) {
            if (debug) {
                console.log('---- openVineyardInfo (' + nodeId + ') ----');
            }
            // Close opened toggled panel
            $('[data-panel-toggled].show').removeClass('show');
            $('[data-panel-to-toggle].active').removeClass('active');

            if (interfaceLevel === 2 || interfaceLevel === 3) {
                if (initInfoLevel2(nodeId)) {
                    // Open info side panel with info automatically
                    let panelToToggle = $('#vineyardInfo');
                    if (panelToToggle) {
                        panelToToggle.toggleClass('show');
                        $('#vineyardsSelect + .vineyard-link').toggleClass('active-info');
                    }
                }
            }
        }

        /**
         * Change the node and map pointing/orientation
         * @param nodeIndex int parte da 0
         */
        function goToVineyard(nodeIndex) {
            if (debug) {
                console.log('---- goToVineyard nodeIndex=' + nodeIndex);
            }

            $('[data-role="vineyard-name"]').html(pano_data.vineyards_repeater[nodeIndex].vineyard_name);

            var panSpeed = 7, //adjust the speed for pano moving
                panDelay = (interfaceLevel === 3) ? 1000 : 0; //adjust the waiting time before pano moving
            var nodeId = pano_data.vineyards_repeater[nodeIndex].node_id;
            var coords;

            try {
                coords = pano_data.vineyards_repeater[nodeIndex].coordinates_3d;
                if (debug) {
                    console.log('----- goToVineyard coords=' + coords);
                }
            } catch (e) {
                return;
            }

            openVineyardInfo(nodeId);
            // set current nodeId
            pano_current_nodeId = nodeId;

            if (typeof pano_0_500 == 'object') {
                if (debug) {
                    console.log('----- goToVineyard  pano_0_500 OK interfaceLevel = ' + interfaceLevel);
                }
                // the panorama change (pano openNext) occurs only at level 3
                if (interfaceLevel === 3) {
                    let destinationNode = '{' + nodeId + '}';
                    if (debug) {
                        console.log('---- goToVineyard destinationNode = ' + destinationNode);
                    }
                    pano_0_500.openNext(destinationNode);
                }
                // placement (pano moveTo) takes place at level 2 and 3 with a delay
                if (interfaceLevel >= 2) {
                    if (debug) {
                        console.log('---- goToVineyard setTimeout');
                    }
                    setTimeout(function () {
                        if (coords) {
                            let arrCoords = coords.split(',');
                            if (debug) {
                                console.log('---- goToVineyard arrCoords = ' + arrCoords);
                            }
                            pano_0_500.moveTo(arrCoords[0], arrCoords[1], arrCoords[2], panSpeed);
                        }
                    }, panDelay);
                }
            } else console.log('ERROR: Pano2VR object not loaded!');
        }

        /**
         * Change level, both the interface and the PANO
         * @param newLevel
         */
        function changeLevel(newLevel) {
            if (debug) {
                console.log('---- change level ----');
            }
            newLevel = parseInt(newLevel);
            // blocks unauthorized changes, the display level cannot exceed the user level
            if (newLevel > userLevel) return;
            interfaceLevel = newLevel;

            // Update PANO
            setPanoLevel(newLevel);
        }

        /**
         * Sets the interface to match the new level, set the visibility of the various elements
         * (Scap: da non chiamare direttamente)
         * @param currentNodeId
         */
        function setInterfaceLevel(currentNodeId) {
            var newLevel = 1 + nodesList.indexOf(currentNodeId);
            if (debug) {
                console.log(' ---- setInterfaceLevel ' + newLevel + ' -----');
            }

            // Update title with selected Vineyard Name
            if (newLevel < 3) $('[data-role="vineyard-name"]').html(pano_data.title);
            else {
                var currentVineyardInfo = pano_data.vineyards_repeater.find(x => x.node_id === currentNodeId);
                if (currentVineyardInfo && currentVineyardInfo.vineyard_name) {
                    $('[data-role="vineyard-name"]').html(currentVineyardInfo.vineyard_name);
                } else {
                    $('[data-role="vineyard-name"]').html(pano_data.title ? pano_data.title : 'Franciacorta');
                }
            }

            // Set thumbs border color
            $('.ggskin_scrollarea .ggskin_cloner').each(function () {
                $(this).find('.ggskin.ggskin_rectangle').css('border', '3px solid rgb(209, 209, 209)');
                $(this).find('.ggskin.ggskin_rectangle').eq(newLevel - 1).css('border', '3px dashed white');
            });

            // Check and select current level on levels menu
            if (newLevel > maxLevels) newLevel = maxLevels;
            if (newLevel > userLevel) newLevel = userLevel;
            interfaceLevel = newLevel;
            $('.changer').removeClass('selected');
            $(".changer[data-level='" + interfaceLevel + "']").addClass('selected'); // attr data-level

            if (debug) {
                console.log(' ----- userLevel = ' + userLevel);
                console.log(' ----- interfaceLevel = ' + interfaceLevel);
                console.log(' ----- maxPanoNodes = ' + maxPanoNodes);
            }
            var showThumbs = (userLevel >= 2); // show thumbs if user level is >=2
            var allThumbs = (userLevel === 3); // show all thumbs only at level 3, otherwise only 2 thumbs
            var showVineyardsComboLegenda = (userLevel >= 2) && (interfaceLevel >= 2); // show the legend and the vineyard dropdown if user level and interface level are >=2

            // Manage PANO Thumbs
            $('.ggskin.ggskin_scrollarea').hide();
            $('.ggskin_cloner').hide();
            if (showThumbs) {
                // show all thumbs
                $('.ggskin_cloner>div').show();
                var thumbs_visible = nodesList.length;
                if (!allThumbs) {
                    // shows only two
                    thumbs_visible = 2;
                    $('.ggskin_cloner>div:gt(1)').hide();
                }
                let thumb_w = 96 * thumbs_visible;
                $('.ggskin_cloner').show();
                $('.ggskin.ggskin_scrollarea').fadeIn();
            }

            // Manage legend and vineyard dropdown
            if (showVineyardsComboLegenda) {
                // Update vineyard dropdown
                $('.vineyard-combo').empty();
                for (var i = 0; i < pano_data.vineyards_repeater.length; i++) {
                    var vineyard = pano_data.vineyards_repeater[i];
                    var name = vineyard['vineyard_name'];
                    var coords = vineyard['coordinates_3d'];
                    var node_id = vineyard['node_id'];
                    var index = i;
                    $('.vineyard-combo').append('<div class="vineyard-element" data-index="' + index + '" data-close-panel-on-click="1">' + name + '</div>');
                }

                // Vineyard change event script
                $('.vineyard-element').each(function (index) {
                    $(this).off("click").on("click", function (event) {
                        if (debug) {
                            console.log('- CLICK vineyard element -');
                        }
                        if (typeof event !== 'undefined') {
                            event.stopPropagation();
                        }

                        var index = $(this).attr('data-index');
                        goToVineyard(index);
                        closeMenu();
                    });
                });

                // Update wine variety legend
                $('[data-role="legenda-content"]').empty();
                for (var i = 0; i < pano_data.legenda.length; i++) {
                    var elem = pano_data.legenda[i];
                    var color = elem['color'];
                    var variety = elem['variety'];
                    $('[data-role="legenda-content"]').append('<div class="variety"><span style="background-color: ' + color + '"></span>' + variety + '</div>');
                }

                // Show level 2 and level 3 elements
                $('.level23').show();
                $('.level1').hide();
            } else {
                initInfoLevel1();
                // Show level 1 elements
                $('.level23').hide();
                $('.level1').show();
            }
        }

        /**
         * Change pano2vr panorama to match the new level
         * (Scap: da non chiamare direttamente)
         * @param newLevel
         */
        function setPanoLevel(newLevel) {
            if (typeof pano_0_500 == 'object') {
                let destinationNode = nodesList[parseInt(newLevel) - 1];
                pano_0_500.openNext('{' + destinationNode + '}'); // trigger PANO changenode
            } else console.log('Err: Pano2VR object not loaded!');
        }

        /**
         * Reset previously instantiated properties
         * @private
         */
        function _resetWindowInstantiatedProperties() {
            if (debug) {
                console.log('- Reset previously instantiated properties');
            }

            // Clear eventually previous instances
            if (pano_current_ggpkg_name && window.hasOwnProperty(pano_current_ggpkg_name + '_pano2vrPlayer')) {
                window[pano_current_ggpkg_name + '_pano2vrPlayer'] = null;
                if (debug) {
                    console.log('--- Set to undefined ' + pano_current_ggpkg_name + '_pano2vrPlayer instance');
                }
            }
            if (pano_current_ggpkg_name && window.hasOwnProperty(pano_current_ggpkg_name + '_pano2vrSkin')) {
                window[pano_current_ggpkg_name + '_pano2vrSkin'] = null;
                if (debug) {
                    console.log('--- Set to undefined ' + pano_current_ggpkg_name + '_pano2vrSkin instance');
                }
            }
        }

    }

    updatePano2VRContent(currentPanoID);

}